import React, { useEffect, useState, useContext, useCallback } from "react";
import {
  useForm,
  FormProvider,
  useFormContext,
  useWatch,
} from "react-hook-form";
import moment from "moment";
//Function
import { getReportSplunk } from "../api";
import { ApiDateTimeFormat, ToDateText } from "../../../utils/date";
//Material Ui
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
//Component
import { BaseContainer } from "../../../stories/base-container";
import Criteria from "../criteria";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ReportTable from "../table";
//Context
import {
  LoadingContext,
  withLoadingContext,
} from "../../../context/loading-context";
const columnsSplunk = [
  {
    id: "SOURCE_TYPE",
    label: "CDR Type",
    minWidth: 170,
    align: "left",
    dataAlign: "left",
  },
  {
    id: "SPLUNK_DTN",
    label: "OFM",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "EDW_DTN",
    label: "EDW",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "SP_DTN_DIFF",
    label: "OFM",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
];
const customheaderSplunk = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell rowSpan={2} align="center">
          Source Type
        </TableCell>
        <TableCell colSpan={4} align="center">
          DTN
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell align="center">Splunk</TableCell>
        <TableCell align="center">BI</TableCell>
        <TableCell align="center">Different</TableCell>
      </TableRow>
    </TableHead>
  );
};
function Splunk() {
  const methods = useForm({
    defaultValues: { date: moment().format(ApiDateTimeFormat) },
  });
  const Loading_context = useContext(LoadingContext);
  const { actions: load_actions } = Loading_context;
  const [Splunk_lst, setSplunk_lst] = useState([]);
  const [date, setDate] = useState();
  const { getValues } = methods;
  const query = useCallback(async () => {
    let param = getValues();
    let dat = await load_actions.withLoading(() => getReportSplunk(param));
    if (!dat) return;
    setSplunk_lst(dat?.Splunk?.Rows);
    setDate(ToDateText(dat?.Date));
  }, [load_actions, getValues]);
  useEffect(() => {
    query();
  }, [query]);
  return (
    <FormProvider {...methods}>
      <BaseContainer>
        {Loading_context.state?.isLoading ? (
          <div className="lineLoading">
            <LinearProgress />
          </div>
        ) : null}
        <Box display="flex" justifyContent="center">
          <Typography variant="h4">splunk-bi report</Typography>
        </Box>
        <Criteria query={query} />
        <Box display="flex" justifyContent="center">{`Date :${
          date || ""
        }`}</Box>
        <ReportTable
          data={Splunk_lst}
          columns={columnsSplunk}
          header={customheaderSplunk}
          cellColor={[{ fieldId: "DTN_DIFF", fieldColor: "DIFF_COLOR_CODE" }]}
        />
      </BaseContainer>
    </FormProvider>
  );
}

export default withLoadingContext(Splunk);
